import type { TDocumentoAnexado } from '@/features/enviar-documentos/interfaces'

type TUpdater = (value: TDocumentoAnexado[] | ((prev: TDocumentoAnexado[]) => TDocumentoAnexado[])) => void

export class DocumentoStatusUpdater {
  constructor(private readonly updater: TUpdater) {
    this.updater = updater
  }

  static readonly create = (updater: TUpdater) => new DocumentoStatusUpdater(updater)

  update = (documentId: string, status: Exclude<TDocumentoAnexado['status'], 'recovered'>) => {
    this.updater((prev) =>
      prev.map((doc) => (doc.status !== 'recovered' && doc.id === documentId ? { ...doc, status } : doc)),
    )
  }
}
